import { render, staticRenderFns } from "./KETextArea.vue?vue&type=template&id=45fa2354&scoped=true&"
import script from "./KETextArea.vue?vue&type=script&lang=ts&"
export * from "./KETextArea.vue?vue&type=script&lang=ts&"
import style0 from "./KETextArea.vue?vue&type=style&index=0&id=45fa2354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fa2354",
  null
  
)

export default component.exports